/*
 *
 * LanguageProvider
 *
 * this component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `app/translations`)
 */

import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import {
  defaultTranslationMessages,
  loadTranslationMessages,
} from '../../i18n';
import { makeSelectLocale } from './selectors';

// ================================================================================
export function LanguageProvider(props) {
  // -- State ---------------------------------------------------------------------
  const [loaded, setLoaded] = useState({ locale: null, messages: null });

  // -- Effect --------------------------------------------------------------------
  useEffect(() => {
    let current = true;

    loadTranslationMessages(props.locale).then(messages => {
      if (current) setLoaded({ locale: props.locale, messages });
    });

    return () => {
      current = false;
    };
  }, [props.locale]);

  // -- UI ------------------------------------------------------------------------
  // The source strings render until this locale's chunk arrives. This is the
  // safety net, not the first-paint path: `useLocaleReady` in AuthRoute holds
  // its loader until the catalog is in memory
  const messages =
    loaded.locale === props.locale
      ? loaded.messages
      : defaultTranslationMessages;
  return (
    <IntlProvider
      locale={props.locale}
      key={props.locale}
      messages={messages}
      textComponent={React.Fragment}
      defaultRichTextElements={{
        b: chunks => <b>{chunks}</b>,
      }}
    >
      {React.Children.only(props.children)}
    </IntlProvider>
  );
}

LanguageProvider.propTypes = {
  locale: PropTypes.string,
  children: PropTypes.element.isRequired,
};

const mapStateToProps = createSelector(makeSelectLocale(), locale => ({
  locale,
}));

export default connect(mapStateToProps)(LanguageProvider);
